import { EntityCreate } from './EntityCreate'
import { EntityEdit } from './EntityEdit'
import { EntityList } from './EntityList'
import { EntityShow } from './EntityShow'

export { EntityCreate, EntityEdit, EntityList, EntityShow }
